import React from 'react';
import DayNavItem from './DayNavItem';
import './DayNav.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';

const DayNav = props => {
    const {
        currentDay,
        language,
        color,
        dayNavigation,
        numberOfDays,
        dayAfterTomorrow,
        maxPerillPerDay,
    } = props;

    return (
        <div className="day-nav">
            <ul>
                <DayNavItem
                    currentDay={currentDay}
                    numberOfDay={0}
                    label={translate(language, 'today')}
                    color={color}
                    dayNavigation={dayNavigation}
                    maxPerill={maxPerillPerDay ? maxPerillPerDay[0] : null}
                />
                <DayNavItem
                    currentDay={currentDay}
                    numberOfDay={1}
                    label={translate(language, 'tomorrow')}
                    color={color}
                    dayNavigation={dayNavigation}
                    maxPerill={maxPerillPerDay ? maxPerillPerDay[1] : null}
                />
                {numberOfDays === 3 && (
                    <DayNavItem
                        currentDay={currentDay}
                        numberOfDay={2}
                        label={dayAfterTomorrow}
                        color={color}
                        dayNavigation={dayNavigation}
                        maxPerill={maxPerillPerDay ? maxPerillPerDay[2] : null}
                    />
                )}
            </ul>
        </div>
    );
};

DayNav.propTypes = {
    numberOfDays: PropTypes.number,
    currentDay: PropTypes.number,
    color: PropTypes.string,
    dayAfterTomorrow: PropTypes.string,
    language: PropTypes.string,
    dayNavigation: PropTypes.func,
    maxPerillPerDay: PropTypes.object,
};

export default DayNav;



// WEBPACK FOOTER //
// ./src/partials/DayNav/DayNav.js